import React, { Component } from 'react';
import './css/networkSelector.css';


const DFP_INDEX = 0,
      FACEBOOK_INDEX = 1,
      MOPUB_INDEX = 2;

const gameOnlyNetworks = [
  'unityads',
  'chartboost'
];


export default class NetworkSelector extends Component{

  constructor(props){
    super(props);

    let adNetworks = [
      {
        title: 'Ad Exchange',
        name: 'dfp',
        logo: 'dfp.png',
        selected: true
      },
      {
        title: "Facebook Audience",
        name: 'facebook',
        logo: 'facebook.png',
        selected: true
      },
      {
        title: 'Mopub',
        name: 'mopub',
        logo: 'mopub.png',
        selected: true
      },
      {
        title: 'Flurry',
        name: 'flurry',
        logo: 'flurry.jpg',
        selected: true
      },
      {
        title: 'Iron Source',
        name: 'ironsource',
        logo: 'ironsource.png',
        selected: true
      },
      {
        title: 'InMobi',
        name: 'inmobi',
        logo: 'inmobi.png',
        selected: true
      },
      {
        title: 'Amazon Ads',
        name: 'amazonads',
        logo: 'amazonads.png',
        selected: true
      },
      {
        title: 'AppLovin',
        name: 'applovin',
        logo: 'applovin.png',
        selected: true
      },
      {
        title: 'Unity Ads',
        name: 'unityads',
        logo: 'unityads.png',
        selected: true
      },
      {
        title: 'Chartboost',
        name: 'chartboost',
        logo: 'chartboost.jpeg',
        selected: true
      },
      {
        title: 'StartApp',
        name: 'startapp',
        logo: 'startapp.jpg',
        selected: true
      }
    ];


    if (!this.props.isGame){
      adNetworks = adNetworks.filter(network => {
        return (
          gameOnlyNetworks.indexOf(network.name) === -1
        );
      });
    }
    
    if (this.props.networks){
      for(let adNetwork of adNetworks){
        adNetwork.selected =
          (this.props.networks.indexOf(adNetwork.name) !== -1);
      }
    }
    
    this.state = {
      adNetworks: adNetworks
    };
  }

  selectNetwork(i){

    let isSelected = this.state.adNetworks[i].selected;
    
    if (i == DFP_INDEX && isSelected){
      this.notify({
        type: 'error',
        msg: 'Ad Exchange is mandatory in current version'
      });
      return;     
    }

    if (i == FACEBOOK_INDEX && isSelected){
      this.notify({
        type: 'error',
        msg: 'Facebook Audience is mandatory in current version'
      });
      return;     
    }
    
    
    this.setState(prevState => {
      prevState.adNetworks[i].selected =
        !prevState.adNetworks[i].selected;
      return prevState;
    });
  }

  get networks(){
    return this.state.adNetworks
      .filter( i => i.selected)
      .map(i => i.name);
  }

      // let numSelectedNetworks =
      //  this.state.newApp.adNetworks.reduce(
      //    (acc, network) => {
      //      if (network.selected){
      //        return acc+1;
      //      } else {
      //        return acc;
      //      }
      //    }, 0);

      // if (numSelectedNetworks == 0){      
      //   this.notify({
      //     type: 'error',
      //     msg: 'You Must Select At Least One Network'
      //   });
      //   return;
      // }

  
  notify(msg){
    if (this.props.notifyHandler){
      this.props.notifyHandler(msg);
    }
  }


  render(){
    let networkItems = this.state.adNetworks.map((network,idx) => (
      <div className={"select-item "+(network.selected ?
           "selected" : "")}
           onClick={ _ => this.selectNetwork(idx)}
           key={idx}>
        <img src={"/assets/img/adnetworks/"+network.logo}/>
          <span>{network.title}</span>
          <i className="fa fa-check-circle selected"/>
          <i className="fa fa-times-circle"/>
      </div>          
    ));

    return (
      <div className="network-selector">
        {networkItems}
        <div className="clearfix"/>
      </div>
    );
  }
  
}





// WEBPACK FOOTER //
// ./src/networkSelector.js